import { useEventCallback } from "@mui/material";
import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import type { GuidedMode } from "../entities/survey-step";
import { DrawerContent } from "./survey-guided-mode-drawer/drawer-content/drawer-content";
import { DrawerHeader } from "./survey-guided-mode-drawer/drawer-header";
import { ResponsiveDrawer } from "./survey-guided-mode-drawer/responsive-drawer";

const SurveyGuidedMode = atom<GuidedMode | undefined>(undefined);
const SurveyGuidedModeIsDrawerOpen = atom<boolean>(false);

export function useOpenGuidedModeDrawer() {
  const setIsDrawerOpen = useSetAtom(SurveyGuidedModeIsDrawerOpen);
  const setGuidedMode = useSetAtom(SurveyGuidedMode);

  const handleOpenDrawer = useEventCallback(function onOpenGuidedModeDrawer(guidedMode: GuidedMode) {
    setGuidedMode(guidedMode);
    setIsDrawerOpen(true);
  });

  return handleOpenDrawer;
}

export function SurveyGuidedModeDrawer() {
  const [isDrawerOpen, setIsDrawerOpen] = useAtom(SurveyGuidedModeIsDrawerOpen);
  const guidedMode = useAtomValue(SurveyGuidedMode);

  const handleCloseDrawer = useEventCallback(function onCloseGuidedModeDrawer() {
    setIsDrawerOpen(false);
  });

  return (
    <ResponsiveDrawer isDrawerOpen={isDrawerOpen} handleCloseDrawer={handleCloseDrawer}>
      <DrawerHeader onClose={handleCloseDrawer} />
      {guidedMode && <DrawerContent guidedMode={guidedMode} />}
    </ResponsiveDrawer>
  );
}
